import React from "react";
import { OrderTypeEnum } from "../enums/OrderEnum";

const preorderSheetForDriver = ({
  pdfData,
  formatDueDeliveryDate,
  isVisible,
  selectedDoctor,
}) => {
  return (
    <div className="pt-4">
      {(Array.isArray(pdfData) ? pdfData : []).map((data, idx) => (
        <div
          key={idx}
          id={`pre-order-sheet-for-driver-${idx}`}
          className={`border-gray border px-12 pb-4 pt-8 m-12 rounded-3xl relative ${""}`}
          style={{
            width: "559px",
            minHeight: "auto",
            backgroundColor: "white",
            breakInside: "avoid",
            top: "-9999px",
            left: "-9999px",
          }}
        >
          <div style={{ pageBreakBefore: "always" }}>
            <div>
              <div>
                <div>
                  <div
                    className={`flex items-start gap-2 font-interBold min-h-[56px] ${
                      data.orderTypeId ===
                      OrderTypeEnum.URGENT_COMPLEX_ORDER_TYPE
                        ? "mb-5"
                        : "mb-8"
                    }`}
                  >
                    <p
                      className={`text-gray-700 flex-1 ${
                        data.orderTypeId ===
                        OrderTypeEnum.URGENT_COMPLEX_ORDER_TYPE
                          ? "text-3xl"
                          : "text-4xl"
                      }`}
                    >
                      Behandler:
                      {(data.orderTypeId ===
                        OrderTypeEnum.URGENT_SIMPLE_ORDER_TYPE) && (
                        <span className="text-red-500">*</span>
                      )}
                    </p>
                    <div className={`flex-1 flex items-center text-gray-600 font-interRegular ${
                        data.orderTypeId ===
                        OrderTypeEnum.URGENT_COMPLEX_ORDER_TYPE
                          ? "text-3xl"
                          : "text-4xl"
                      }`}>
                      <p>{data?.dentistName}</p>
                    </div>
                  </div>
                </div>
                {data?.patientName != "" && (
                  <div className="flex items-center justify-between gap-2 mb-5 font-interBold">
                    <p className="text-2xl text-gray-700">Patient:</p>
                    <div className="flex items-center justify-between gap-2 text-2xl text-gray-600 font-interRegular">
                      <p>{data?.patientName}</p>
                    </div>
                  </div>
                )}
              </div>
              {data.orderTypeId === OrderTypeEnum.URGENT_COMPLEX_ORDER_TYPE ? (
                <div className="flex items-center justify-between gap-2 mb-5 pb-3 font-interBold">
                  <p className="text-2xl text-gray-700">Due Date:</p>
                  <div className="flex items-center justify-between gap-2 text-2xl text-gray-600 font-interRegular">
                    <p>{formatDueDeliveryDate(data?.dueDeliveryDate)}</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default preorderSheetForDriver;
